import React from 'react';

import { useSelector } from 'react-redux';

import UserProfileCompletionThailandForm from '@/components/shared/complete-profile/UserProfileCompletionThailandForm';
import UserProfileCompletionForm from '@/components/shared/complete-profile/UserProfileCompletionForm';
import {
  selectFastRegMxV2Tag,
  selectIsFastRegTh,
  selectUserSpecificTag,
} from '@/store/selectors/userSelectors';
import { envIsMexico } from '@/constants/constants';
import CompleteProfileMexicoPhone from '@/pages/settings/verify/CompleteProfileMexicoPhone';
import CompleteProfileMexicoCurp from '@/pages/settings/verify/CompleteProfileMexicoCurp';
import CompleteProfileMexico from '@/pages/settings/verify/CompleteProfileMexico';

const UserCompleteProfileFormManager = ({ onSuccess }: { onSuccess?: VoidFunction }) => {
  const isFastRegTh = useSelector(selectIsFastRegTh);
  const isFastRegMxTag = useSelector(selectUserSpecificTag('Fastreg_mx'));
  const isFastRegMxV2TagPresent = useSelector(selectFastRegMxV2Tag);

  // Normal (Thailand)
  if (isFastRegTh) {
    return <UserProfileCompletionThailandForm onSuccess={onSuccess} />;
  }

  // Normal
  if (!envIsMexico()) {
    return <UserProfileCompletionForm onSuccessCallback={onSuccess} />;
  }

  // Mexico
  if (isFastRegMxV2TagPresent) {
    return <CompleteProfileMexicoPhone />;
  } else if (isFastRegMxTag) {
    return <CompleteProfileMexicoCurp />;
  } else {
    return <CompleteProfileMexico />;
  }
};

export default UserCompleteProfileFormManager;
